import { DnvFeatureLayer, DnvLayerActionType, FeatureFilterPayload, FeatureFilterUpdate, Layer, LayerType } from 'dnv-lib';
import { GetExclusionLayerMainsSuccess, WMRPAction, WMRPActionType } from './wmrp.action';
import { WMRPState, WmrpAnalysisRun, initialWMRPState } from './wmrp.state';
import { ApplicationState, GridPayload, GridSelectLayerPayload, initialApplicationState } from '../application/application.state';
import { applicationReducer, parseGridSelectLayerPayload } from '../application/application.reducer';

export function wmrpReducer(
    state: WMRPState = initialWMRPState,
    action: WMRPAction): WMRPState {
    switch (action.type) {

        case WMRPActionType.SetWMRPModule:
            return Object.assign({}, state, {
                module: action.payload
            });

        case WMRPActionType.SetMaterialsDictionary:
            return Object.assign({}, state, {
                materials: action.payload
            });

        case WMRPActionType.SetTemplateNames:
            return Object.assign({}, state, {
                templates: action.payload
            });

        case WMRPActionType.SetDefaultConditions:
        case WMRPActionType.SetTemplateParameters:
            return Object.assign({}, state, {
                currentConditions: action.payload
            });

        case WMRPActionType.SaveTemplateParametersSuccess:
            return Object.assign({}, state, {
                savedTemplate: parseConditions(action.payload)
            });

        case WMRPActionType.ShowExpandParametersBtn:
            return Object.assign({}, state, {
                showExpandParametersBtn: action.payload
            });

        case WMRPActionType.SetRecentAnalysisDetails:
            return Object.assign({}, state, {
                recentAnalysisRunData: action.payload
            });

        case WMRPActionType.SelectRun:
            return Object.assign({}, state, {
                selectedRun: action.payload
            });

        case WMRPActionType.AddRecentAnalysisDetails:
            return Object.assign({}, state, {
                recentAnalysisRunData: [action.payload, ...state.recentAnalysisRunData]
            });

        case WMRPActionType.SetReplacementSchedules:
            return Object.assign({}, state, {
                replacementSchedules: action.payload
            });

        case WMRPActionType.SetSelectedReplacementSchedule:
            return Object.assign({}, state, {
                selectedReplacementSchedule: action.payload
            });

        case WMRPActionType.SetWmrtResults:
            return Object.assign({}, state, {
                wmrpResults: action.payload
            });

        case WMRPActionType.SetWmrtBoundary:
            return Object.assign({}, state, {
                wmrpState: action.payload
            });

        case WMRPActionType.SetWMRPLayerFeatureVisible:
            const modLayers = updateLayersVisibility(action.payload, state.layers);
            return Object.assign({}, state, {
                layers: modLayers
            });

        case WMRPActionType.SetWMRPLayers:
            return Object.assign({}, state, {
                layers: action.payload
            });


        case WMRPActionType.SetWMRPActiveLayer: {
            const selectedlayer = action.payload as Layer;

            return Object.assign({}, state, {
                layers: updateLayerType(state.layers
                    , state.layers.findIndex(layer => layer.id === selectedlayer.id)
                    , LayerType.Active)
            });
        }

        case WMRPActionType.SetWMRPAvailableLayer: {
            const selectedlayer = action.payload as Layer;

            const newLayers = updateLayerType(state.layers
                , state.layers.findIndex(layer => layer.id === selectedlayer.id)
                , LayerType.Available);
            return Object.assign({}, state, {
                layers: newLayers
            });
        }

        case WMRPActionType.UpdateWMRPLayerFilter: {
            const payload: FeatureFilterPayload = action.payload as FeatureFilterPayload;
            const selectedLayer = payload.layer;
            const selectedLayerIndex = state.layers.findIndex(layer => layer.id === selectedLayer.id);
            const selectedFeatureLayer = payload.featureLayer;
            const selectedFeatureLayerIndex = state.layers[selectedLayerIndex]
                .featureLayers.findIndex(featureLayer => featureLayer.uid === selectedFeatureLayer.uid);
            const layers = updateLayerFilter(state.layers
                , selectedLayerIndex
                , selectedFeatureLayerIndex
                , payload.featureFilterUpdate);
            const s = Object.assign({}, state, { layers });

            return s;
        }


        case WMRPActionType.GetExclusionLayerMainsSuccess:
            return Object.assign({}, state, {

                exclusionLayerMains: (() => {
                    const p: GridSelectLayerPayload = (action as GetExclusionLayerMainsSuccess).payload;
                    // const p: GridSelectLayerPayload = action.payload;
                    const gp: GridPayload = parseGridSelectLayerPayload(p);
                    const cache: Map<string, GridPayload> = new Map<string, GridPayload>(state.exclusionLayerMains);
                    cache.set(p.dnvFeatureLayer.uid, gp);
                    return cache.get('WMRP_EXCLUSION').data; // use just cache to access geometry
                })()
            });

        case WMRPActionType.ToggleWMRPLayer:
            const layerIdx = state.layers.findIndex(l => l.id === action.payload.id);
            let lyrs = Object.assign({}, state.layers);

            if (layerIdx > -1) {
                lyrs = [...state.layers.slice(0, layerIdx),
                Object.assign({}, state.layers[layerIdx], { expand: !action.payload.expand }),
                ...state.layers.slice(layerIdx + 1)];
            }

            return Object.assign({}, state, {
                layers: lyrs
            });


        default:
            return state;
    }
}

function parseConditions(payload: any): any {
    const parsedData = payload.wmrpAnalysisParams.map((d: any) => {
        return {
            ...d,
            conditions: JSON.parse(d.conditions as string),
            moduleId: d.wmrpModule_Id
        };
    });

    return Object.assign({}, payload, {
        wmrpAnalysisParams: parsedData
    });
}

function updateLayersVisibility(payload: FeatureFilterPayload, layers: Layer[]) {
    const layer = payload.layer;
    const layerIndex = layers.findIndex(l => l.id === layer.id);
    const theStateLayer = layers[layerIndex];
    const featureLayer = payload.featureLayer;
    let newFeatureLayers: DnvFeatureLayer[] = [];
    let layerIsVisible: boolean;

    // Toggle a single feature layer
    if (featureLayer) {
        const featureLayerIndex = theStateLayer.featureLayers.findIndex(f => f.uid === featureLayer.uid);
        newFeatureLayers = [
            ...theStateLayer.featureLayers.slice(0, featureLayerIndex),
            Object.assign({}, featureLayer, { isVisible: !theStateLayer.featureLayers[featureLayerIndex].isVisible }),
            ...theStateLayer.featureLayers.slice(featureLayerIndex + 1)
        ];
        layerIsVisible = newFeatureLayers.reduce((accumulator, currentValue) => accumulator && currentValue.isVisible, true);
    } else { // Toggle the entire layer
        layerIsVisible = !theStateLayer.isVisible;
        newFeatureLayers = theStateLayer.featureLayers.map(fl => Object.assign({}, fl, { isVisible: layerIsVisible }));
    }

    return [
        ...layers.slice(0, layerIndex),
        Object.assign({}, layers[layerIndex], { featureLayers: newFeatureLayers, isVisible: layerIsVisible }),
        ...layers.slice(layerIndex + 1)
    ];

}

function updateLayerType(layers: Layer[], index: number, newType: LayerType) {

    let targetLayer: Layer = null;
    if (newType === 1) { // going back to available layers, collapse
        targetLayer = Object.assign({}, layers[index], {
            type: newType,
            expand: false,
            featureLayers: layers[index]?.featureLayers.map(f => Object.assign({}, f, { isVisible: true }))
        });
    } else {
        targetLayer = Object.assign({}, layers[index], {
            type: newType
        });
    }

    const newLayers = [...layers.slice(0, index),
        targetLayer,
    ...layers.slice(index + 1)];

    return newLayers;
}

function updateLayerFilter(layers: Layer[], layerIndex: number, featureLayerIndex: number
    , featureFilterUpdate: FeatureFilterUpdate): Layer[] {
    let newWhereClause = '';
    featureFilterUpdate.newFilters.forEach(f => {
        if (f.name.toLowerCase().indexOf('_reference') > -1) {
            newWhereClause = newWhereClause + f.name + ' in (\'' + f.filter + '\') ';
        } else if (f.type === 'esriFieldTypeString') {
            newWhereClause = newWhereClause + ' AND ' + f.name + ' LIKE \'' + f.filter + '%\'';
        }

    })
    console.log(newWhereClause);
    const featureLyr = Object.assign({}, layers[layerIndex].featureLayers[featureLayerIndex], {
        fieldFilters: featureFilterUpdate.newFilters,
        whereClause: newWhereClause
    });
    console.log(featureLyr);

    const newLayers = [...layers.slice(0, layerIndex),
    Object.assign({}
        , layers[layerIndex]
        , {
            featureLayers: [
                ...layers[layerIndex].featureLayers.slice(0, featureLayerIndex),
                featureLyr,
                ...layers[layerIndex].featureLayers.slice(featureLayerIndex + 1)
            ]
        }
    ),
    ...layers.slice(layerIndex + 1)];
    console.log(newLayers);
    return newLayers;
}